var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.33333,
    cy: 4.99935,
    r: 3.33333,
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 14.584C15.0003 16.6551 15.0003 18.334 8.33366 18.334C1.66699 18.334 1.66699 16.6551 1.66699 14.584C1.66699 12.5129 4.65176 10.834 8.33366 10.834C12.0156 10.834 15.0003 12.5129 15.0003 14.584Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0734 10.4481L15.5285 9.85186L15.0734 10.4481ZM15.833 7.2023L15.3011 7.73108C15.4419 7.87268 15.6333 7.9523 15.833 7.9523C16.0327 7.9523 16.2241 7.87268 16.3649 7.73108L15.833 7.2023ZM16.5926 10.4481L16.1376 9.85186L16.5926 10.4481ZM15.5285 9.85186C15.1156 9.53677 14.7645 9.29916 14.4801 8.98913C14.2215 8.7072 14.083 8.42878 14.083 8.08245H12.583C12.583 8.91313 12.947 9.53682 13.3747 10.0031C13.7766 10.4413 14.2957 10.798 14.6184 11.0443L15.5285 9.85186ZM14.083 8.08245C14.083 7.78818 14.2541 7.5557 14.4647 7.46251C14.634 7.38756 14.9329 7.36065 15.3011 7.73108L16.3649 6.67352C15.6082 5.91239 14.657 5.73706 13.8576 6.09082C13.0995 6.42635 12.583 7.19972 12.583 8.08245H14.083ZM14.6184 11.0443C14.7414 11.1381 14.9091 11.2665 15.0875 11.3674C15.2662 11.4686 15.5236 11.5827 15.833 11.5827V10.0827C15.8924 10.0827 15.8998 10.1036 15.8261 10.0619C15.7521 10.02 15.665 9.95607 15.5285 9.85186L14.6184 11.0443ZM17.0476 11.0443C17.3703 10.798 17.8894 10.4413 18.2913 10.0031C18.719 9.53682 19.083 8.91313 19.083 8.08245H17.583C17.583 8.42878 17.4446 8.7072 17.1859 8.98913C16.9016 9.29916 16.5504 9.53677 16.1376 9.85186L17.0476 11.0443ZM19.083 8.08245C19.083 7.19972 18.5666 6.42635 17.8084 6.09082C17.009 5.73706 16.0578 5.91239 15.3011 6.67352L16.3649 7.73108C16.7331 7.36065 17.032 7.38756 17.2014 7.46251C17.4119 7.5557 17.583 7.78818 17.583 8.08245H19.083ZM16.1376 9.85186C16.001 9.95607 15.9139 10.02 15.8399 10.0619C15.7662 10.1036 15.7736 10.0827 15.833 10.0827V11.5827C16.1424 11.5827 16.3998 11.4686 16.5785 11.3674C16.7569 11.2665 16.9246 11.1381 17.0476 11.0443L16.1376 9.85186Z",
    fill: "#2058E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4053_20083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadCreate);
export default __webpack_public_path__ + "static/media/LeadCreate.55e0b50a60adf2747ff44208940d04a4.svg";
export { ForwardRef as ReactComponent };